import { PropsWithChildren, ReactNode } from 'react';
import { useICSContext } from 'components/IAP/planningView/ICSContext';
import { CollapsibleCard } from 'components/DesignSystems/Collapse/CollapsibleCard';
import { useUscgMapContext } from 'components/MapPage/CorporateViewTabs/LayersTab/UscgMapContext';

interface ConditionalCollapsibleCardProps {
  sectionKey: string;
  headerLeft: ReactNode;
  headerRight?: ReactNode;
  className?: string;
  headerClassName?: string;
  contentClassName?: string;
  onCollapse?: () => void;
  onStateChange?: (isExpanded: boolean) => void;
  defaultCollapsed?: boolean;
  /** When false the card stays open and the header is not a collapse control. */
  collapsible?: boolean;
}

export const ConditionalCollapsibleCard = (
  props: PropsWithChildren<ConditionalCollapsibleCardProps>
) => {
  const { isMapVisible } = useUscgMapContext();
  const { isFuture } = useICSContext();

  if (isMapVisible && isFuture) {
    return <div className={props.contentClassName}>{props.children}</div>;
  }

  return <CollapsibleCard {...props} />;
};
